import React, { useEffect, useState } from 'react';
import { isMobile } from '@pascal/pascal-core';

import { ResultCardsEnum, TKeys } from '../../../enums';
import { marketsStore } from '../../../store/marketsStore';
import { groupedBetTableData, handleRtpTableData } from '../../../helpers';

export const GameSpecificCheckHashPopupTopSection = ({ currentData }) => {
  return (
    <div className='res-cont-circle-wrp'>
      <div className={`res-cont-circle-holder `}>
        <div
          className={`res-cont-circle-ins ${
            ResultCardsEnum[currentData?.roundData?.resultCard]
              ? ResultCardsEnum[currentData.roundData.resultCard]
              : 'static'
          }`}
        />
      </div>
    </div>
  );
};

export const AboutHashInnerContent = ({ t }) => {
  return (
    <>
      <p className='pr-f-text'>{isMobile() && t(TKeys.FairnessModalTitle)}</p>
      <p className='pr-f-text'>{t('GAME_FAIRNESS_P1')}</p>
      <p className='pr-f-text w-b-ba'>
        40C32E00D4A0FD5C42767A67D52D7E5D59387BAC4086AC1FC5990371E1DFA642822CCE359B0E17A5051E8AC3D340662BCDA53B8BCA2908F04A72D3D54B7B951C:
      </p>
      <p className='pr-f-text'>{t('GAME_FAIRNESS_P2')}</p>
      <p className='pr-f-text'>{t('GAME_FAIRNESS_P3')}</p>
      <p className='pr-f-text'>{t('GAME_FAIRNESS_P4')}</p>

      <ol className='pr-f-text'>
        <li className='pr-f-text'>{t('GAME_FAIRNESS_P5')}</li>
        <li className='pr-f-text'>{t('GAME_FAIRNESS_P6')}</li>
        <li className='pr-f-text'>{t('GAME_FAIRNESS_P7')}</li>
        <li className='pr-f-text'>{t('GAME_FAIRNESS_P8')}</li>
      </ol>
      <p className='pr-f-text'>{t('GAME_FAIRNESS_P9')}</p>
      <p className='pr-f-text'>{t('GAME_FAIRNESS_P10')}</p>
      <p className='pr-f-text'>{t('GAME_FAIRNESS_P11')}</p>
      <p className='pr-f-text w-b-ba'>
        40C32E00D4A0FD5C42767A67D52D7E5D59387BAC4086AC1FC5990371E1DFA642822CCE359B0E17A5051E8AC3D340662BCDA53B8BCA2908F04A72D3D54B7B951C
      </p>
    </>
  );
};

export const HelpPopupInnerContent = ({ t }) => {
  const { allMarkets, hiLoMarketsData } = marketsStore;
  const [correctBetTypes, setCorrectBetTypes] = useState([]);

  useEffect(() => {
    handleRtpTableData(allMarkets, setCorrectBetTypes);
  }, [allMarkets, hiLoMarketsData]);

  return (
    <div className='result-content-b'>
      <div className='fs-help-popup-text'>
        {new Array(7).fill(null).map((el, index) => (
          <p key={`GAME_RULES_P${index + 1}`}>{t(`GAME_RULES_P${index + 1}`)}</p>
        ))}
        <ul>
          {new Array(45).fill(null).map((el, index) => (
            <li key={`GAME_RULES_P${index + 8}`}>{t(`GAME_RULES_P${index + 8}`)}</li>
          ))}
        </ul>
        <p>{t('GAME_RULES_P53')}</p>
        <p>{t('GAME_RULES_P54')}</p>
        <p>{t('GAME_RULES_P55')}</p>
        <ul>
          {new Array(3).fill(null).map((el, index) => (
            <li key={`GAME_RULES_P${index + 56}`}>{t(`GAME_RULES_P${index + 56}`)}</li>
          ))}
        </ul>
        {new Array(11).fill(null).map((el, index) => (
          <p key={`GAME_RULES_P${index + 59}`}>{t(`GAME_RULES_P${index + 59}`)}</p>
        ))}
        <p>{t('GAME_RULES_P90')}</p>
        <p>{t('GAME_RULES_P70')}</p>
        <p>{t('GAME_RULES_P71')}</p>
        <table className='odds2'>
          <thead>
            <tr>
              <th>{t('GAME_RULES_P72')}</th>
              <th>{t('RTP_FOR_HI')}</th>
              <th>{t('GAME_RULES_P73')}</th>
              <th>{t('RTP_FOR_LO')}</th>
              <th>{t('GAME_RULES_P74')}</th>
            </tr>
          </thead>
          <tbody>
            {correctBetTypes.map(({ hi, rtpHi, type, rtpLo, lo }, index) => (
              <tr key={index}>
                <td>{hi}</td>
                <td>{rtpHi}</td>
                <td>{type}</td>
                <td>{rtpLo}</td>
                <td>{lo}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className='fs-help-popup-text'>
          <p>{t('GAME_RULES_P75')}</p>
          <p>{t('GAME_RULES_P76')}</p>
        </div>
        <table className='odds2'>
          <thead>
            <tr>
              <th>{t('GAME_RULES_P77')}</th>
              <th>{t('GAME_RULES_P78')}</th>
            </tr>
          </thead>
          <tbody>
            {groupedBetTableData(allMarkets).map((item, index) => (
              <tr key={index + 1}>
                <td>{t(item.name)}</td>
                <td>{item.odd}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className='fs-help-popup-text'>
          <p>
            {t('CANCELATION_MESSAGE_1')}
            <br />
            {t('MALFUNCTION_MESSAGE_2')}
          </p>
          <p>{t('RTP')}</p>
        </div>
      </div>
    </div>
  );
};
